import { render, staticRenderFns } from "./switching-unit.vue?vue&type=template&id=2df2f683&scoped=true";
import script from "./switching-unit.vue?vue&type=script&lang=js";
export * from "./switching-unit.vue?vue&type=script&lang=js";
import style0 from "./switching-unit.vue?vue&type=style&index=0&id=2df2f683&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "2df2f683", null);
export default component.exports;